export const SUPPORTED_LOCALES = ['de', 'en'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALE_CONFIG: Record<
  SupportedLocale,
  {
    name: string;
    nativeName: string;
    flag: string;
    direction: 'ltr' | 'rtl';
  }
> = {
  de: { name: 'German', nativeName: 'Deutsch', flag: '\u{1F1E9}\u{1F1EA}', direction: 'ltr' },
  en: { name: 'English', nativeName: 'English', flag: '\u{1F1EC}\u{1F1E7}', direction: 'ltr' },
};

export const DEFAULT_LOCALE: SupportedLocale = 'de';
